import { EarnType } from '~/lib/constants'
import { CONFIG } from '~/lib/config'
import { ChainId } from 'symbiosis-js-sdk'

const earnPaths = {
	[EarnType.sushiSwap]: '/sushi-swap',
	[EarnType.uniSwap]: '/uni-swap',
	[EarnType.pancakeSwap]: '/pancake-swap',
}

export const earnTypeByPathName = (pathName: string): EarnType => {
	return Object.keys(earnPaths).find(
		(earnPathKey) => earnPaths[earnPathKey] == '/' + pathName
	) as EarnType
}

export const earnTypeByChainId = (chainId: ChainId): EarnType => {
	return Object.keys(CONFIG.earns).find(
		(earnType) => CONFIG.earns[earnType].chainId === chainId
	) as EarnType
}

export const pathToEarnPage = (earnType: EarnType, page?: string) =>
	`/lp-farm${earnPaths[earnType]}${page ? `/${page}` : ''}`
